module.exports = __webpack_public_path__ + "static/media/bgImage.949c2661.jpg";